import { render, staticRenderFns } from "./writeBoard.vue?vue&type=template&id=0d766f50&scoped=true&"
import script from "./writeBoard.vue?vue&type=script&lang=js&"
export * from "./writeBoard.vue?vue&type=script&lang=js&"
import style0 from "./writeBoard.vue?vue&type=style&index=0&id=0d766f50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d766f50",
  null
  
)

export default component.exports